<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <span class="text-h5 font-weight-bold ml-3 full-width page-header"
        >{{ $t("menu.survey") }}
        <v-btn icon x-small class="mx-2" @click="openManual()">
          <v-icon color="#404040">mdi-alert-circle-outline</v-icon>
        </v-btn>
      </span>
      <v-spacer></v-spacer>
      <div class="mr-4 my-1">
        <search-input class="" v-model="search" :label="$t('lblSearchTextSurvey')" :labelTooltip="$t('lblSearchTextSurveyTooltip')"></search-input>
      </div>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-if="$security.checkUserAccess('CreateSurveyPolls')"
            class="mr-4"
            color="primaryDark"
            dark
            v-bind="attrs"
            v-on="on"
            :to="`/survey/add/new/survey`"
            ><v-icon size="16">mdi-plus</v-icon
            >{{ $t("poll.btnSurvey") }}</a-btn
          >
        </template>
        <span v-html="toolTipCreateSurvey"></span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-if="$security.checkUserAccess('CreateSurveyPolls') && false"
            v-bind="attrs"
            v-on="on"
            :to="`/poll/add/new/survey`"
            color="primaryDark"
            dark
            ><v-icon size="16">mdi-plus</v-icon>{{ $t("poll.btnPoll") }}</a-btn
          >
        </template>
        <span v-html="toolTipPollSurvey"></span>
      </v-tooltip>
    </template>
    <template v-slot:page-content>
      <v-card flat tile style="width: 100%" color="Neutral">
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12" class="pa-0">
              <v-row v-if="loaderLoading">
                <v-col
                  v-for="n in 12"
                  :key="n"
                  cols="12"
                  sm="12"
                  md="6"
                  lg="4"
                  style="padding: 10px"
                >
                  <v-skeleton-loader
                    height="150"
                    type="card"
                  ></v-skeleton-loader>
                </v-col>
              </v-row>
              <survey-grid
                v-else
                :items="getSurvey"
                :search="search"
              ></survey-grid>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- <create-poll v-model="showCreatePollDialog"></create-poll> -->
      <confirm-dialog ref="confirmDelete" />
      <message-sheet
        v-if="$store.state.alertMessage !== null"
        :showMessage="$store.state.alertMessage !== null ? true : false"
        :message="$store.state.alertMessage.message"
        :messageType="$store.state.alertMessage.variant"
        @close="alertClose"
      ></message-sheet>
    </template>
  </page-container>
</template>

<script>
import AvatarGroup from "@/components/poll/AvatarGroup.vue";
import CreatePoll from "@/components/poll/CreatePoll.vue";
import CreateSurvey from "@/components/poll/CreateSurvey.vue";
import { mapActions, mapState } from "vuex";
import RadioButtonChoice from "./RadioButtonChoice.vue";
import CheckBoxChoice from "./CheckBoxChoice.vue";
import _ from "lodash";
import PollQuestion from "./PollQuestion.vue";
import SurveyQuestions from "./SurveyQuestions.vue";
import ConfirmDialog from "../ConfirmDialog.vue";
import SurveyResponse from "./SurveyResponse.vue";
import SurveyResult from "./SurveyResult.vue";
import SurveyGrid from "./SurveyGrid.vue";
import SearchInput from "../SearchInput.vue";
import Loader from "../Loader.vue";
import MessageSheet from "../MessageSheet.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import AAutocompletes from "../../wrapper-component/AAutocompletes.vue";
export default {
  components: {
    CreatePoll,
    AvatarGroup,
    CreateSurvey,
    RadioButtonChoice,
    CheckBoxChoice,
    PollQuestion,
    SurveyQuestions,
    ConfirmDialog,
    SurveyResponse,
    SurveyResult,
    SurveyGrid,
    SearchInput,
    Loader,
    MessageSheet,
    AAutocompletes,
  },
  mixins: [SignalRMixin],
  name: "PollSurvey",
  SurveyQuestions,
  data() {
    return {
      manualClick: 0,
      manualWindow: {},
      loaderLoading: false,
      displayMessage: false,
      messageType: "",
      message: "",
      tab: null,
      search: "",
      selectedGroupItem: [],
      knowledge: 33,
      selected: [2],
      itemsList: [
        {
          action: "15 min",
          headline: "Brunch this weekend?",
          subtitle: `I'll be in your neighborhood doing errands this weekend. Do you want to hang out?`,
          title: "Ali Connors",
        },
        {
          action: "2 hr",
          headline: "Summer BBQ",
          subtitle: `Wish I could come, but I'm out of town this weekend.`,
          title: "me, Scrott, Jennifer",
        },
        {
          action: "6 hr",
          headline: "Oui oui",
          subtitle: "Do you have Paris recommendations? Have you ever been?",
          title: "Sandra Adams",
        },
        {
          action: "12 hr",
          headline: "Birthday gift",
          subtitle:
            "Have any ideas about what we should get Heidi for her birthday?",
          title: "Trevor Hansen",
        },
        {
          action: "18hr",
          headline: "Recipe to try",
          subtitle:
            "We should eat this: Grate, Squash, Corn, and tomatillo Tacos.",
          title: "Britta Holt",
        },
      ],
      showCreatePollDialog: false,
      showCreateSurveyDialog: false,
      selectedItem: null,
      isMultiple: true,
      questions: [
        {
          type: "poll",
          question: "Most popular programming languages in 2022?",
          options: [
            {
              text: "Java Script",
              voteCount: 1,
            },
            {
              text: "Python",
              voteCount: 3,
            },
            {
              text: "C#",
              voteCount: 6,
            },
            {
              text: "Java",
              voteCount: 7,
            },
          ],
        },
        {
          type: "poll",

          question: "Next?",
          options: [
            {
              text: "Java Script",
              voteCount: 1,
            },
            {
              text: "Python",
              voteCount: 3,
            },
            {
              text: "C#",
              voteCount: 6,
            },
            {
              text: "Java",
              voteCount: 7,
            },
          ],
        },
        {
          type: "poll",

          question: "Other question?",
          options: [
            {
              text: "Java Script",
              voteCount: 1,
            },
            {
              text: "Python",
              voteCount: 3,
            },
            {
              text: "C#",
              voteCount: 6,
            },
            {
              text: "Java",
              voteCount: 7,
            },
          ],
        },
        {
          type: "survey",
          title: "Survey questions",
          questions: [
            {
              question: "hello 1",
              options: [
                { text: "option 1", value: 1 },
                { text: "option 2", value: 2 },
                { text: "option 3", value: 3 },
                { text: "option 4", value: 4 },
              ],
            },
            {
              question: "hello 2",
              options: [
                { text: "option 1", value: 1 },
                { text: "option 2", value: 2 },
                { text: "option 3", value: 3 },
                { text: "option 4", value: 4 },
              ],
            },
          ],
        },
      ],
      surveyQuestions: null,
      // surveyQuestions: [
      //   {
      //     question: "hello 1",
      //     options: [
      //       { text: "option 1", value: 1 },
      //       { text: "option 2", value: 2 },
      //       { text: "option 3", value: 3 },
      //       { text: "option 4", value: 4 },
      //     ],
      //   },
      //   {
      //     question: "hello 2",
      //     options: [
      //       { text: "option 1", value: 1 },
      //       { text: "option 2", value: 2 },
      //       { text: "option 3", value: 3 },
      //       { text: "option 4", value: 4 },
      //     ],
      //   },
      // ],
      itemsM: [
        { title: "Hitesh" },
        { title: "Anil" },
        { title: "Abc" },
        { title: "Xyz" },
      ],
      items: [
        {
          text: "Java Script",
          voteCount: 1,
        },
        {
          text: "Python",
          voteCount: 3,
        },
        {
          text: "C#",
          voteCount: 6,
        },
        {
          text: "Java",
          voteCount: 7,
        },
      ],
      model: [],
    };
  },
  computed: {
    ...mapState({
      pollSurveyQuestions: (state) => state.poll.pollSurveyQuestions,
      surveyResponseResult: (state) => state.poll.surveyResponseResult,
    }),
    getSurvey() {
      return this.pollSurveyQuestions.filter((item) => item.type === "survey");
    },
    surveyQuestionsDetails() {
      return this.surveyQuestions ? this.surveyQuestions : {};
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    toolTipCreateSurvey() {
      return this.$t("poll.tipCreateSurvey");
    },
    toolTipPollSurvey() {
      return this.$t("poll.tipCreatePoll");
    },
  },
  mounted,
  methods: {
    ...mapActions({
      getSurveyList: "poll/getSurveyList",
      getSurveyById: "poll/getSurveyById",
      getSurveyResult: "poll/getSurveyResult",
      deleteSurvey: "poll/deleteSurvey",
    }),
    createPoll,
    onItemClick,
    createSurvey,
    onPollSurveyQuestionClick,
    updateAnswer,
    onSubmitSurvey,
    onDeleteSurvey,
    ConfirmDelete,
    getDateWords,
    onEditSurvey,
    openManual() {
      this.manualClick += 1;
      let height = screen.height;
      let width = screen.width;
      let strWindowFeatures =
        "location=no,toolbar=no,menubar=no,height=" +
        height +
        ",width=" +
        width +
        ",scrollbars=auto,fullscreen=yes";
      let routeData = this.$router.resolve({
        path: "/usermanual",
        query: { content: this.$i18n.locale == "en" ? "Manual_E_Survey.pdf" : "Manual_J_Survey.pdf", id: this.$route.name },
      });
      let popup;
      if (
        routeData &&
        (typeof this.manualWindow === "undefined" ||
          this.manualWindow.closed ||
          this.manualClick === 1)
      ) {
        popup = window.open(routeData.href, "_blank", strWindowFeatures);
        this.manualWindow = popup;
        popup.moveTo(0, 0);
      } else {
        this.manualWindow.focus();
      }
    },
    alertClose() {
      this.$store.commit("setAlert", null);
    },
    signalRInit(target) {
      this.signalConnection.on(target, async (message) => {
        const result = JSON.parse(message);
        try {
          if (result && this.$security.checkUserAccess("ViewSurveyPolls")) {
            await this.getSurveyList();
          }
        } catch (error) {
          console.log(error, "API error");
        }
      });
      if (
        this.signalConnection.connectionState.toLowerCase() === "disconnected"
      ) {
        this.signalConnection.start().catch();
      }
    },
  },
};

function onEditSurvey(id) {
  this.$router.push(`/survey/${id}`);
}

function getDateWords(paramData) {
  const endDate = new Date(paramData);

  const movingDate = new Date();
  // movingDate.setDate(movingDate.getDate() + 1);

  const today = new Date();
  const tomorrow = new Date(movingDate.setDate(movingDate.getDate() + 1));
  const nexDay1 = new Date(movingDate.setDate(movingDate.getDate() + 1));
  const nexDay2 = new Date(movingDate.setDate(movingDate.getDate() + 1));
  const nexDay3 = new Date(movingDate.setDate(movingDate.getDate() + 1));
  const nexDay4 = new Date(movingDate.setDate(movingDate.getDate() + 1));
  const nexDay5 = new Date(movingDate.setDate(movingDate.getDate() + 1));
  const nextWeek = new Date(movingDate.setDate(movingDate.getDate() + 1));

  if (endDate < today) return "Today " + formatDate(endDate, "h:mm aaa");
  if (endDate < tomorrow) return "Tomorrow " + formatDate(endDate, "h:mm aaa");
  if (endDate < nexDay1) return dayOfWeekNames[endDate.getDay()];
  if (endDate < nexDay2) return dayOfWeekNames[endDate.getDay()];
  if (endDate < nexDay3) return dayOfWeekNames[endDate.getDay()];
  if (endDate < nexDay4) return dayOfWeekNames[endDate.getDay()];
  if (endDate < nexDay5) return dayOfWeekNames[endDate.getDay()];
  if (endDate < nextWeek) return "Next Week";

  return formatDate(new Date(), "MM/dd/yyyy h:mm aaa");
}

async function onDeleteSurvey(item) {
  const answer = await this.ConfirmDelete();
  if (answer) {
    await this.deleteSurvey(item.id);
    this.surveyQuestions = null;
  }
}

async function mounted() {
  try {
    this.loaderLoading = true;
    this.signalRInit(`surveys_${this.selectedTenant}`);
    if (this.$security.checkUserAccess("ViewSurveyPolls")) {
      if (this.pollSurveyQuestions.length) {
        this.getSurveyList();
      } else {
        await this.getSurveyList();
      }
    }
    this.loaderLoading = false;
  } catch (error) {
    this.loaderLoading = false;
  }
}

function onSubmitSurvey() {
  const answer = _.cloneDeep(
    this.surveyQuestions.questions.map((x) => {
      return {
        answer: x.selectedAnswer,
        questionId: x.id,
      };
    })
  );
  const finalResult = {
    id: this.surveyQuestions.id,
    user: this.$auth.user.tenantUserName,
    tenantId: sessionStorage.getItem("tenantId"),
    submitDate: new Date().toISOString(),
    questionAnswers: answer,
  };
}

function updateAnswer(question, answer) {
  question.selectedAnswer = answer;
}

async function onPollSurveyQuestionClick(item) {
  // this.surveyQuestions = await this.getSurveyById(id);
  // this.surveyQuestions = item;
  const params = {
    surveyid: item.id,
    userid: this.$auth.user.tenantUserName,
  };
  if (this.$security.checkUserAccess("ViewSurveyPolls") && item.id) {
    const result = await this.getSurveyResult(params);
    if (result) {
      item.questions.forEach((question) => {
        const data = result.questionAnswers.findIndex(
          (x) => x.questionId === question.id
        );
        if (data > -1) {
          question.selectedAnswer = result.questionAnswers[data].answer;
        }
      });
    }
  }
  this.surveyQuestions = item;
}

async function ConfirmDelete() {
  if (
    await this.$refs.confirmDelete.open(
      this.$t("agenda.hDeleteMessage"),
      this.$t("agenda.lblDeleteMessage")
    )
  ) {
    return true;
  }
}

function createSurvey() {
  this.showCreateSurveyDialog = true;
}

function onItemClick(item, question) {
  // item.voteCount++;
  this.selectedItem = item;
  question.selectedAnswer = item;
  // item.isSelected = !item.isSelected;
}

function createPoll() {
  this.showCreatePollDialog = true;
}

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const dayOfWeekNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
function formatDate(date, patternStr) {
  if (!patternStr) {
    patternStr = "M/d/yyyy";
  }
  var day = date.getDate(),
    month = date.getMonth(),
    year = date.getFullYear(),
    hour = date.getHours(),
    minute = date.getMinutes(),
    second = date.getSeconds(),
    miliseconds = date.getMilliseconds(),
    h = hour % 12,
    hh = twoDigitPad(h),
    HH = twoDigitPad(hour),
    mm = twoDigitPad(minute),
    ss = twoDigitPad(second),
    aaa = hour < 12 ? "AM" : "PM",
    EEEE = dayOfWeekNames[date.getDay()],
    EEE = EEEE.substr(0, 3),
    dd = twoDigitPad(day),
    M = month + 1,
    MM = twoDigitPad(M),
    MMMM = monthNames[month],
    MMM = MMMM.substr(0, 3),
    yyyy = year + "",
    yy = yyyy.substr(2, 2);
  // checks to see if month name will be used
  patternStr = patternStr
    .replace("hh", hh)
    .replace("h", h)
    .replace("HH", HH)
    .replace("H", hour)
    .replace("mm", mm)
    .replace("m", minute)
    .replace("ss", ss)
    .replace("s", second)
    .replace("S", miliseconds)
    .replace("dd", dd)
    .replace("d", day)

    .replace("EEEE", EEEE)
    .replace("EEE", EEE)
    .replace("yyyy", yyyy)
    .replace("yy", yy);
  // .replace("aaa", aaa);
  if (patternStr.indexOf("MMM") > -1) {
    patternStr = patternStr.replace("MMMM", MMMM).replace("MMM", MMM);
  } else {
    patternStr = patternStr.replace("MM", MM).replace("M", M);
  }
  return patternStr.replace("aaa", aaa);
}

function twoDigitPad(num) {
  return num < 10 ? "0" + num : num;
}
</script>

<style scoped>
.border {
  border: 1px solid gray;
}
.group-item-list {
  margin-top: 2px;
  margin-bottom: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}
.expire-label {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
}

.vote-label {
  font-size: 0.688rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
  color: darkblue;
}
.basil {
  background-color: #e1efff !important;
}
.basil--text {
  color: white !important;
}

.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: grey;
}

.tab-slider-color {
  color: #356859;
}
</style>
